/*
 * @Description:
 * @Date: 2024-01-9 16:59:01
 */

const views = (require as any).context('./', true, /pc-module-table-\d+\.vue/);
export default views.keys().map(path => {
  return views(path).default;
});
